import { Component, Inject, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { ApiService } from "src/app/core/services/api-service";
import Swal from "sweetalert2";

@Component({
  selector: "app-for-observation-dialog",
  templateUrl: "./for-observation-dialog.component.html",
  styleUrls: ["./for-observation-dialog.component.scss"],
})
export class ForObservationDialogComponent implements OnInit {
  date = new FormControl(new Date().toISOString());

  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: ApiService
  ) {}

  ngOnInit(): void {}

  handleSubmit() {
    Swal.fire({
      title: "Are you sure?",
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      denyButtonColor: "#e74c3c",
      confirmButtonColor: "#4DAF50",
    }).then((result) => {
      if (result.isConfirmed) {
        this.approveForm(3, "").subscribe((res) => {
          window.location.reload();
        });
      }
    });
  }

  approveForm(id: number, reason: string) {
    const formData: FormData = new FormData();
    formData.append("EvalStatus", `${id}`);
    formData.append("ReasonForChange", `${reason}`);
    formData.append("NonCompliantType", "0");
    formData.append("CourtClearanceNumber", "");
    formData.append("PoliceClearanceType", "");
    formData.append(
      "NextEvaluationDate",
      new Date(this.date.value).toISOString()
    );
    const url = `/evaluator/update-status/${this.data.application.id}`;

    return this.api.put(url, formData);
  }
}
